export const sonicFeatures = {
    asyncCollections: "ar",
    restrictedRoutes: "rr",
};
export const X_DISCO_WEBSITE_HOSTNAME = "X-disco-website-hostname";

